module.exports = __webpack_public_path__ + "static/media/silkycloud-black-4.0f3bc6f4.png";